<template>
  <main>
    <h1>Riman</h1>
    <Riman />
  </main>
</template>

<script>
import Riman from "./components/Riman";
export default {
  name: "App",
  components: {
    Riman,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #385879;
  margin-top: 60px;
  display: flex;
  justify-content: center;
}

main {
  width: 60vw;
  background-color: #e8ecf4;
  padding-bottom: 2rem;
  border-radius: 8px;
}

@media (max-width: 1130px) {
  main {
    width: 70vw;
    background-color: #e8ecf4;
    padding-bottom: 2rem;
    border-radius: 8px;
  }
}

@media (max-width: 1000px) {
  main {
    width: 80vw;
    background-color: #e8ecf4;
    padding-bottom: 2rem;
    border-radius: 8px;
  }
}

@media (max-width: 900px) {
  main {
    width: 90vw;
    background-color: #e8ecf4;
    padding-bottom: 2rem;
    border-radius: 8px;
  }
}

@media (max-width: 800px) {
  main {
    width: 100vw;
    background-color: #e8ecf4;
    padding-bottom: 2rem;
    border-radius: 8px;
  }
}
</style>
